<template>
  <div>
    <textarea class="intro__textarea" v-model="intro_content" name="" id="" cols="30" rows="10" placeholder="请输入门店简介"></textarea>
    <div class="sureBtn__box"><button @click="sureBtn">确认</button></div>
  </div>
</template>

<script>
  export default {
    name: "storeInfo_intro",
    data(){
      return{
        store_id:0,
        intro_content:''
      }
    },
    created(){
      this.store_id = this.$route.query.store_id
      this.intro_content = this.$route.query.intro_content
    },
    methods:{
      sureBtn(){
        if(!this.intro_content){
          this.$toast('门店简介不能为空！');
          return false
        }
        this.axios({
          url: this.api.store.store_desc_edit,
          data: {
            store_id:this.store_id,
            desc:this.intro_content
          }
        }).then(res => {
          if (res.error === 0) {           
            this.$router.push({path:'/storeInfo',query:{store_id:this.store_id}});
          }
        });        
      
      }
    }
  }
</script>

<style scoped>
  .intro__textarea{
    background: #fff;
    width: 100%;
    padding: .75rem;
    font-size: .7rem;
  }

  .sureBtn__box{
    padding-top: 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/store/storeInfo_intro.vue